import {environment} from '@env';

export function openCommonItemInReact(
    itemTag: string,
    queryParams?: Record<string, string>,
): void {

    if (environment.reactUrl != null) {
        const search = queryParams ? '?' + new URLSearchParams(queryParams).toString() : '';
        window.open(`${environment.reactUrl}/menu-builder/common-item-details/${itemTag}${search}`, '_blank');
    }
}
